export default __webpack_public_path__ + "static/media/logo.a1c20189.svg";